import { render, staticRenderFns } from "./ProjectTemplates.vue?vue&type=template&id=1dbde24a&scoped=true&"
import script from "./ProjectTemplates.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplates.vue?vue&type=style&index=0&id=1dbde24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbde24a",
  null
  
)

export default component.exports